<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import axios from "axios";


export default {

    data() {
        return {
            jobs: [],
            departments: [],
            offices: [],
        }
    },

    mounted () {
          this.getData("jobs", true);
          this.getData("departments");
          this.getData("offices");
    },
    methods: {
        getData(object, content) {
            let url = "https://boards-api.greenhouse.io/v1/boards/" + process.env.VUE_APP_GH_BOARD;
            let requestUrl = url + '/' + object + (content ? '?content=true' : '');
            axios
              .get(requestUrl)
              .then(response => {
                this[object] = response.data[object];
              });
        }
    }

}

</script>

<style>

#app {
    --primary-background: var(--white);
    --primary-text: var(--black-almost);
    --primary-container-background: var(--grey-dark);
    --primary-toggle-background: var(--white);
    --primary-progress-background: var(--black-almost-transparent);
    --primary-border-left: var(--black-almost-transparent-20);
    --blue: #3265E5;
    --red: #dc3545;
    --white: #FFFFFF;
    --white-transparent: rgba(255,255,255,.10);
    --white-transparent-20: rgba(255,255,255,.20);
    --white-transparent-35: rgba(255,255,255,.35);
    --black-almost: #171717;
    --black-almost-transparent: rgba(23,23,23,.10);
    --black-almost-transparent-20: rgba(23,23,23,.20);
    --grey: #A1A1A1;
    --grey-dark: #8A8E99;
    --grey-darkest: #1E1E1E;
    --black: #000000;
    --purple: #8737D3;
    --pink: #D037BD;

    font-family: "Helvetica Neue Regular";
    color: var(--primary-text);  
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#app table {
    text-align: left;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.accordion-button::after {
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%20class%3D%22bi%20bi-plus-lg%22%20viewBox%3D%220%200%2016%2016%22%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M8%202a.5.5%200%200%201%20.5.5v5h5a.5.5%200%200%201%200%201h-5v5a.5.5%200%200%201-1%200v-5h-5a.5.5%200%200%201%200-1h5v-5A.5.5%200%200%201%208%202Z%22%2F%3E%0A%3C%2Fsvg%3E") !important;
    transform: rotate(0deg);
}

.accordion-button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%20class%3D%22bi%20bi-dash-lg%22%20viewBox%3D%220%200%2016%2016%22%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M2%208a.5.5%200%200%201%20.5-.5h11a.5.5%200%200%201%200%201h-11A.5.5%200%200%201%202%208Z%22%2F%3E%0A%3C%2Fsvg%3E") !important;
    transform: rotate(0deg);
}

.job-title {
    font-family: "Helvetica Neue Regular";
    font-weight: 400;
    font-size: 60px;
    line-height: 60px;
    letter-spacing: -0.01em;
    text-transform: uppercase;
    background: -webkit-linear-gradient(45deg, #09009f, #00ff95 80%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.job-applying {
    font-family: "Helvetica Neue Thin";
    font-size: 40px;
    color: var(--blue);
}

.job-meta {
    font-family: "Helvetica Neue Light";
    font-size: 18px;
    line-height: 26px;
}

.job-meta strong{
  font-weight: 700;
}

.job-meta span {
    font-family: "Helvetica Neue Light";
    text-transform: uppercase;
}

.job-description {
    font-family: "Helvetica Neue Light";
    font-size: 18px;
    line-height: 24px;
}

.job-description p strong {
    font-weight: normal;
    font-size: 32px;
    line-height: 55px;
}

.job-align-center {
    width: 100%;
    text-align: center;
    margin: 0 auto;
}

.pay-input > .title {
    font-family: "Helvetica Neue Regular";
    font-weight: 700;
    font-size: 20px;
    line-height: 38px;
}

.pay-input > .pay-range {
    padding-bottom: 20px;
    font-family: "Helvetica Neue Light";
    font-weight: 300;
    font-size: 20px;
    line-height: 28px;
}

.ac_desc_title {
  font-family: "Helvetica Neue Regular";
  font-weight: 700;
  font-size: 20px;
  line-height: 38px;
}

.ac_desc_desc {
  padding-bottom: 20px;
  font-family: "Helvetica Neue Light";
  font-weight: 300;
  font-size: 20px;
  line-height: 28px;
}

.office label, .department label {
    font-family: "Helvetica Neue Light";
    font-size: 16px;
    line-height: 24px;
}

.office, .department {
    margin-bottom: 12px;
}

#app .accordion-button:not(.collapsed) {
    color: var(--black-almost);
    background-color: var(--white);
}

#app .accordion-button {
    font-family: "Helvetica Neue Light";
    font-size: 22px;
    line-height: 28px;
}

#app .accordion-item {
    border: none;
    border-bottom: 1px solid rgb(222, 226, 230);
}

#app #job {
    padding-top: 100px;
}

.table>:not(:first-child) {
    border-top: none !important;
}

div.job-listing-job {
    height: 114px;
}

div.job-listing-title {
    font-family: "Helvetica Neue Light";
    font-size: 22px;
    line-height: 15px;
}

div.job-listing-meta {
    font-size: 16px;
    line-height: 24px;
}

#app a {
    text-decoration: none;
    color: var(--black-almost);
}

.checkbox-round {
    width: 1em;
    height: 1em;
    background-color: var(--white);
    border-radius: 50%;
    vertical-align: middle;
    border: 2px solid var(--white);
    appearance: none;
    -webkit-appearance: none;
    outline: 1px solid var(--grey);
    cursor: pointer;
    margin-right: 10px;
}

.checkbox-round:checked {
    background-color: var(--black-almost);
}

.filter-header {
    font-family: "Helvetica Neue Light";
    font-size: 16px;
    line-height: 20px;
    padding-left: 20px;
    padding-bottom: 20px;
    padding-right: 20px;
    border-bottom: 1px solid rgb(222, 226, 230);
}

@media (max-width: 991.98px) {
    #filter-container {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999999999999;
        background-color: var(--white);
        height: 100%;
        width: 100%;
        overflow-y: scroll;
        padding: 0;
        padding-top: 20px;
    }

    .job-title {
        font-size: 32px;
        line-height: 32px;
    }
}
</style>
